import React from 'react'
import { Link } from 'react-router-dom'
import { slide as Menu } from 'react-burger-menu';
import { addDoc, collection, getDocs } from 'firebase/firestore';
import {db} from './firebase';
import Modal from './Modal';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function Dashboard() {
   const [info , setinfo] = React.useState([]);
   const [modal , setmodal] = React.useState(false);
   const[imageurl,setimageurl] = React.useState();
   const[name , setname] = React.useState();
   const[repo , setrepo] = React.useState();
   const[url,seturl] = React.useState();
   const[tech,settech]  = React.useState();

   function handlex(e)
   {
       setimageurl(e.target.value);
      }

      function handley(e)
      {
        setname(e.target.value);
      }

      function handlez(e)
      {
        setrepo(e.target.value);
      }

      function handlea(e)
      {
        seturl(e.target.value);
      }

      function handleb(e)
      {
        settech(e.target.value);
      }


      async function submit()
      {
        await addDoc(usersCollectionRef, {name:name,iconurl :imageurl ,gitrepo:repo , weblink : url ,language:tech})
        alert("data submitted");
      }
     
   
function handlebutton()
{
    var flag = modal;
    flag = !flag;
   setmodal(flag);
}



    const usersCollectionRef = collection(db,localStorage.length>0 ? localStorage.getItem("mail"):"users"); 
    React.useEffect(()=>{
        const getUser = async() =>  
        {
         const data = await getDocs(usersCollectionRef);
           setinfo(data.docs.map((doc)=>({...doc.data(),id:doc.id})));
           console.log(info);
        }
        getUser() 
        },[])



  return (
    <div>

<header className="text-gray-600 body-font">
  <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
    <nav className="flex lg:w-2/5 flex-wrap items-center text-base md:ml-auto">
      <Link to = '/admin' className="mr-5 hover:text-lg hover:text-gray-900">

      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
</svg>

      </Link>
  
    </nav>
    <a className="flex order-first lg:order-none lg:w-1/5 title-font font-medium items-center text-gray-900 lg:items-center lg:justify-center mb-4 md:mb-0">
     
      <img src='hackscript.png'   className="logoimg"  ></img>
      <span className="ml-3 text-sm">HackScript DashBoard</span>
    </a>
    <div className="lg:w-2/5 inline-flex lg:justify-end ml-5 lg:ml-0">
    <img
    id="avatarButton"
    className="w-10 h-10 rounded-full mx-7 bg-blue-100"
    src={localStorage.getItem("pics")}
  />
</div>
<div className='backwall w-full lg:w-1/3 '>



<div className='absolute left-7 top-56'>
   
    <img src={localStorage.getItem("pics")} className ="ava"/>
    <h1 className='text-gray-900 text-3xl'>{localStorage.getItem("names")}   </h1>



    <Popup trigger={<button> Add Projects </button> } modal>
    <div><section className="text-gray-600 body-font relative">
  <div className="container px-5 py-7 mx-auto">
    <div className="flex flex-col text-center w-full mb-12">
      <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
       Add Projects 
      </h1>
      <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
      Your Project is reviewed by hackscript Team Before putting in Dev-Wall
      </p>
    </div>
    <div className="lg:w-1/2 md:w-2/3 mx-auto">
      <div className="flex flex-wrap -m-2">
        <div className="p-2 w-1/2">
          <div className="relative">
            <label htmlFor="name" className="leading-7 text-sm text-gray-600">
              Icon Of Project (Url)
            </label>
            <input
              type="text"
              id="name"
              name="name"
              onChange={handlex}
              className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
        </div>
        <div className="p-2 w-1/2">
          <div className="relative">
            <label htmlFor="name" className="leading-7 text-sm text-gray-600">
              Name 
            </label>
            <input
              type="text"
              id="name"
              name="name"
              onChange={handley}
              className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
        </div>
        <div className="p-2 w-1/2">
          <div className="relative">
            <label htmlFor="name" className="leading-7 text-sm text-gray-600">
              Github Repo
            </label>
            <input
              type="text"
              id="name"
              name="name"
              onChange={handlez}
              className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
        </div>
        <div className="p-2 w-1/2">
          <div className="relative">
            <label htmlFor="email" className="leading-7 text-sm text-gray-600">
              Deployed URL
            </label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={handlea}
              className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
        </div>
        <div className="p-2 w-full">
          <div className="relative">
            <label
              htmlFor="message"
              className="leading-7 text-sm text-gray-600"
            >
             Tech-Stacks
            </label>
            <textarea
              id="message"
              name="message"
              onChange={handleb}
              className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
              defaultValue={""}
            />
          </div>
        </div>
        <div className="p-2 w-full">
          <button  onClick={submit}  className="flex mx-auto text-white bg-blue-700 border-0 py-2 px-8 focus:outline-none hover:bg-green-500 rounded text-lg">
          Add Project
          </button>

        </div>
        
          </div>
    </div>
  </div>
</section>
</div>
  </Popup>



</div>
</div>
<hr></hr>
<div className='mainbody'>
    <h1 className=' text-red-600 text-2xl'>About Me</h1>
  
    <h1 className=' text-gray-900 text-lg'>Hey I am Passionate Developer  </h1>
<br></br>
<h1 className=' text-red-600 text-2xl'>Badges</h1>
  
    <h1 className=' text-gray-400 text-lg'>No Badges </h1>

    <h1 className=' text-red-600 text-2xl mt-7'>Your Ranking </h1>
    <h1 className=' text-gray-400 text-lg'>Not Justified </h1>

<hr></hr>
<Popup trigger={<button> My-Console</button>} modal>
    <div>
    <section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">
    <div className="flex flex-col text-center w-full mb-20">
      <h1 className="sm:text-4xl text-3xl font-medium title-font mb-2 text-gray-900">
        {localStorage.getItem("names")}
      </h1>
    </div>
    <div className="w-full mx-auto overflow-auto">
      <table className="table-auto w-full text-left whitespace-no-wrap">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100 rounded-tl rounded-bl">
              Icon
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100">
             Name
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100">
            Git-Repo
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100">
             URL
            </th>
            <th className="w-10 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-100 rounded-tr rounded-br" />
          </tr>
        </thead>
        <tbody>          
          
          {info.map((infos)=>{return<>

            <tr>
<td>   <img
    id="avatarButton"
    className="w-10 h-10 rounded-full mx-7 bg-blue-100"
    src={infos.iconurl}
  /></td>

<td>{infos.name}</td>
<td><a href={infos.gitrepo}>
<button class="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 my-3 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white  focus:outline-none">
  <span class="relative px-1 py-0.2 transition-all ease-in duration-75  bg-white rounded-md group-hover:bg-opacity-0">
      Git-Repo
  </span>
</button>
  </a></td>
<td>
<a href={infos.weblink}>
<button class="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 my-3 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group  bg-gradient-to-br from-red-200 via-red-300 to-yellow-200  group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white  focus:ring-4 focus:outline-none">
  <span class="relative px-1 py-0.2 transition-all ease-in duration-75 bg-white rounded-md group-hover:bg-opacity-0">
      Live-Link
  </span>
</button>
  </a>

</td>
</tr>

    </>})}
       
        </tbody>
      </table>
    </div>

  </div>
</section>





    </div>
  </Popup>


<hr></hr>

<Link to="/play"><button type="button" className=" my-7 text-white bg-[#050708] hover:bg-[#050708]/90 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#050708]/50 dark:hover:bg-[#050708]/30 mr-2 mb-2">
  <svg class="mr-2 -ml-1 w-5 h-5" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="apple" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"></path></svg>
Open Hack-Script-Store
</button></Link>

    </div> 

  
  

    
  </div>
</header>


<footer/>









    </div>
  )
}

export default Dashboard